@import 'common/stylesheets/mixins/common.styl'
@import 'common/stylesheets/components/mp-card-header.styl'
@import 'common/stylesheets/components/mp-skeleton'

.select-org-modal-container
  .action-text
    font-size $font-size-small
    font-weight $weight-medium
    margin-bottom 8px
    padding 0 20px

  .input-area
    max-height 450px
    overflow auto
    padding 0 20px 20px 20px
    width 345px


  .org-card
    border 1px solid var(--component-outline-color)
    border-radius 4px
    box-shadow 0px 0px 1px rgba($gray3, 0.24), 0px 2px 4px rgba($gray3, 0.16)
    cursor pointer
    margin-bottom 16px

    &:hover
      background-color var(--secondary-background-color)
      box-shadow 0px 0px 1px rgba($gray5, 0.24), 0px 2px 4px rgba($gray5, 0.16)

      .org-card-container
        svg-icon-style(size: 24px)
        .org-name
          font-weight $weight-medium



    .org-card-container
      align-items center
      display flex
      padding 12px

      .org-name
        font-size $font-size-medium
        font-weight $weight-regular

      .caret-icon
        margin-left auto
        svg-icon-style(size: 16px)

